module.exports = __webpack_public_path__ + "34e74a921e49545b758cf387d1b20b36.svg";